import { Provider } from 'react-redux';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { theme } from './theme.ts';
import { store } from './app-store.ts';
import { AppRouter } from './app-router.tsx';
import { AppLoader } from './app-loader.tsx';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

import '../shared/styles/general.css';

export const App = () => {

  return (
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <Notifications position="top-center" zIndex={2077} />
        <ModalsProvider>
          <AppLoader>
            <AppRouter />
          </AppLoader>
        </ModalsProvider>
      </MantineProvider>
    </Provider>
  );
}
